import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { BASE_URL_APISERVICES, BASE_URL_BUMPPY } from "../../utils/Constants";


export const updateUserDetails = async (req) => {
    try {

        let username = "NoMoreOwnerName@bumppy.com";
        let password = "HJpdmF0ZSBzdGF0aWMgZmluYWwgU3RyaW5n";

        var myHeaders = new Headers();
        myHeaders.append(
            "Authorization",
            "Basic " + Buffer.from(username + ":" + password).toString("base64")
          );
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify(req);

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        const res = await fetch(
            `${BASE_URL_APISERVICES}${API_ENDPOINTS.userDetailsUpdate}`,
            requestOptions
        );
        return await res.json();

    } catch (error) {
        console.error({error})
        throw new Error("User Update Failed.");
    }
};

export const aepsLog = async (req) => {
    try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify(req);

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        const res = await fetch(
            `${BASE_URL_BUMPPY}${API_ENDPOINTS.RECON_REPORT}`,
            requestOptions
        );
        return await res.json();

    } catch (error) {
        console.error({error})
        throw new Error("Failed.");
    }
};
